import React from 'react';
import {
  Button,
  CheckCircleOutlineIcon,
  CheckIcon,
  Stack,
  Text,
} from '@billda/design-system';
import { SiteImportResponse } from '../../../api/sitesApi';

interface ImportSuccessStepProps {
  importResult: SiteImportResponse;
  onViewSite: () => void;
}

const ImportSuccessStep: React.FC<ImportSuccessStepProps> = ({
  importResult,
  onViewSite,
}) => {
  const summaryRows = [
    { label: 'Site name', value: importResult.siteName },
    { label: 'Site code', value: importResult.slug },
    { label: 'Plots', value: importResult.plotCount.toLocaleString() },
    {
      label: 'Labour items',
      value: importResult.labourItemCount.toLocaleString(),
    },
    {
      label: 'Total value',
      value: new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP',
      }).format(importResult.totalValue),
    },
  ];

  return (
    <div data-testid="import-success-step">
      <Stack spacing={3} alignItems="center">
        <CheckCircleOutlineIcon
          className="size-16 text-content-success"
          aria-hidden="true"
        />

        <div className="text-center">
          <Text variant="h5" className="font-semibold">
            Site created!
          </Text>
          <Text variant="body1" color="secondary">
            Your site is ready to go.
          </Text>
        </div>

        <div className="w-full rounded-xl border border-border-default bg-surface-default p-6">
          <Stack spacing={1.5}>
            {summaryRows.map(row => (
              <div
                key={row.label}
                className="flex items-center justify-between"
              >
                <Text variant="body2" color="secondary">
                  {row.label}
                </Text>
                <Text variant="body2" className="font-semibold">
                  {row.value}
                </Text>
              </div>
            ))}
          </Stack>
        </div>

        <Button
          variant="outline"
          onClick={onViewSite}
          className="px-8 font-bold"
          data-testid="import-success-view-site-button"
        >
          <CheckIcon
            className="size-4 text-content-success"
            aria-hidden="true"
          />
          View Site
        </Button>
      </Stack>
    </div>
  );
};

export default ImportSuccessStep;
